import React, { useState } from "react";
import "../../style/Footer/ButtonsCompartir.css";
import Button from "react-bootstrap/Button";
import { addAnswerProperty } from "../../helpers";
import { useAppContext } from "../../AppContext";
import { APIfetchApi } from "../../utils/APIfetchApi";
import CustomModal from "../styleComponents/CustomModal";

export default function ButtonsCobrar({ ...props }) {
  const { globalState, setGlobalState } = useAppContext({});
  const APIKEY = process.env.APIKEY;
  const [open, setOpen] = useState(false);

  const ENDPOINTSPOT = process.env.REACT_APP_URL_BASE;

  const onCloseModal = () => setOpen(false);

  const handleSaveSpot = async () => {
    const fetchApi = new APIfetchApi();
    let headerConsulta = new Headers();
    let endpointExtra;
    headerConsulta.append("Access-Control-Allow-Origin", "*");
    headerConsulta.append("Access-Control-Allow-Headers", "*");
    headerConsulta.append("Content-Type", "application/json");
    headerConsulta.append("apiKey", APIKEY);
    if (globalState.jwt !== undefined) {
      endpointExtra = "/try-recharge";
      headerConsulta.append("token", globalState.jwt);
    } else {
      endpointExtra =
        "/response/addRespondentAndAnswers/" + globalState.whatsapp;
    }
    let resp = {};
    let restQuestions, concatQuestions;
    const questionSeparator = globalState.allQuestions.findIndex(
      (question) => question.type === "image_choice_single"
    );
    if (globalState.likeVideo) {
      restQuestions = globalState.allQuestions.slice(questionSeparator);
      concatQuestions = globalState.questions.answers.concat(restQuestions);
    } else {
      restQuestions = globalState.allQuestions.slice(0, questionSeparator + 1);
      concatQuestions = restQuestions.concat(globalState.questions.answers);
    }
    concatQuestions = addAnswerProperty(concatQuestions);
    let request = {};
    if (globalState.whatsapp) {
      request = {
        utms: globalState.utms,
        studyId: globalState.studyId,
        respondent: "52" + globalState.phoneNumber,
        answers: concatQuestions,
        sectionIdWeb: globalState.shortUuid,
        companyCellphone: globalState.company,
        amount: globalState.amount,
      };
    } else {
      request = {
        utms: globalState.utms,
        studyId: globalState.studyId,
        respondent: "52" + globalState.phoneNumber,
        answers: concatQuestions,
        sectionIdWeb: globalState.shortUuid,
      };
    }

    if (globalState.jwt !== undefined) {
      request = {
        numberRecharge: "52" + globalState.phoneNumber,
        companyCellphone: globalState.company,
        amountRecharge: globalState.amount,
      };
    }
    const response = await fetchApi.fetchApi(
      headerConsulta,
      "POST",
      request,
      ENDPOINTSPOT + endpointExtra
    );

    if (response.status === 200) {
      resp = await response.json();
      if (globalState.whatsapp) {
        if (resp === true) {
          setGlobalState({
            ...globalState,
            step: "7",
            succesFinal: true,
          });
        } else {
          if (resp.jwt === undefined) {
            if (resp.message === "The cellphone exists in this study.") {
              setGlobalState({
                ...globalState,
                step: "7",
                succesFinal: true,
              });
            } else {
              setGlobalState({
                ...globalState,
                step: "7",
                succesFinal: false,
                phoneNumber: "",
              });
            }
          } else {
            setGlobalState({
              ...globalState,
              step: "7",
              succesFinal: false,
              phoneNumber: "",
              jwt: resp.jwt,
            });
          }
        }
      } else {
        if (
          resp === true ||
          resp.message === "The cellphone exists in this study."
        ) {
          setGlobalState({
            ...globalState,
            step: "7",
            succesFinal: true,
          });
        } else {
          setGlobalState({
            ...globalState,
            step: "7",
            succesFinal: false,
            phoneNumber: "",
          });
        }
      }
    } else {
      if (resp.jwt === undefined) {
        setGlobalState({
          ...globalState,
          step: "7",
          succesFinal: false,
          phoneNumber: "",
        });
      } else {
        setGlobalState({
          ...globalState,
          step: "7",
          succesFinal: false,
          phoneNumber: "",
          jwt: resp.jwt,
        });
      }
    }
  };

  const handleSelectCobrar = () => {
    if (
      globalState.phoneNumber.length === 10 &&
      /^\d+$/.test(globalState.phoneNumber)
    ) {
      handleSaveSpot();
    } else {
      if (globalState.whatsapp) {
        setOpen(true);
      } else {
        handleSaveSpot();
      }
    }
  };

  return (
    <>
      <Button
        variant="outline-primary"
        className="btn-icon-cob"
        onClick={() => handleSelectCobrar()}
      >
        {globalState.whatsapp ? (
          <span className="button-text">Cobrar mi recompensa</span>
        ) : (
          <span className="button-text">Finalizar</span>
        )}
      </Button>
      <CustomModal isOpenModal={open} onClose={onCloseModal} title={"¡Aviso!"}>
        <h2 className="text-white">El número es incorrecto.</h2>
      </CustomModal>
    </>
  );
}
